import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import TurnusStore from 'src/stores/TurnusStore';
import ObjednavkaStore from 'src/stores/ObjednavkaStore';
import KlientStore from 'src/stores/KlientStore';
import { inject, observer } from 'mobx-react';
import {
    Drawer,
    Grid,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Paper,
    TextField,
    Button,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    LinearProgress
} from '@material-ui/core';
import NavigationDrawerItems from './NavigationDrawerItems';
import { observable, action, computed } from 'mobx';
import MenuIcon from '@material-ui/icons/Menu';
import PreparePaymentDetailsResponse from 'src/services/response/PreparePaymentDetailsResponse';
import SendPaymentDetailsResponse from 'src/services/response/SendPaymentDetailsResponse';
import Klient from 'src/models/Klient';
import Turnus from 'src/models/Turnus';

export interface IPaymentDetailsReviewProps extends RouteComponentProps<any> {
    klientStore?: KlientStore;
    turnusStore?: TurnusStore;
    objednavkaStore?: ObjednavkaStore;
    objednavkaId: number;
}

@inject('klientStore')
@inject('turnusStore')
@inject('objednavkaStore')
@observer
class PaymentDetailsReview extends React.Component<IPaymentDetailsReviewProps>{

    // GUI controls
    @observable private isDrawerOpened: boolean = false;
    @observable private isAlertDialogOpened: boolean = false;
    @observable private isProgressBarOpened: boolean = false;

    @action
    private drawerMenuClick = event => {
        this.isDrawerOpened = !this.isDrawerOpened;
    }

    private alertDialogClose = event => {
        this.isAlertDialogOpened = false;
    }

    // Data
    @observable private emailText: string = "";
    @observable private emailAddress: string = "adresa@nemam.cz";
    @observable private klienti: Klient[] = [];

    @observable private dataLoaded: boolean = false;

    @computed private get loadStarted(): boolean {
        if(!this.dataLoaded) {
            this.props.objednavkaStore.preparePaymentDetails(this.props.objednavkaId)
            .then((resp: PreparePaymentDetailsResponse) => {
                this.emailText = resp.emailText;
                this.loadClients();

                if(this.klienti.length > 0) {
                    this.emailAddress = this.klienti[0].email;
                }

                this.dataLoaded = true;
            })
        }
        return true;
    }

    @action
    private handleChange = name => event => {
        this[name] = event.target.value;
    };

    @action
    private doSend = () => {
        this.isProgressBarOpened = true;
        this.props.objednavkaStore.sendPaymentDetails(this.props.objednavkaId, this.emailAddress, this.emailText)
        .then((resp: SendPaymentDetailsResponse) => {
            if(resp.response === true) {
                this.props.objednavkaStore.getObjednavkaByID(this.props.objednavkaId).stav = 'odeslany';
                this.props.history.push(`/orders/${this.props.objednavkaId}`)
            }
        },
        reason => {
            this.isAlertDialogOpened = true;
            this.isProgressBarOpened = false;
        });
    }

    private loadClients = () => {
        const turnusy: Turnus[] = this.props.turnusStore.getTurnusyByObjednavkaID(this.props.objednavkaId);
        const clients: Set<number> = new Set();
        turnusy.forEach(turnus => {
            clients.add(turnus.idKlient);
        });
        const retVal: Klient[] = [];
        clients.forEach((cl) => {
            const klient = this.props.klientStore.getClientById(cl);
            retVal.push(klient);
        });
        this.klienti = retVal;
    }

    public render() {
        return (
            <div>
            <Drawer open={this.isDrawerOpened} onClose={this.drawerMenuClick}>
                <NavigationDrawerItems />
            </Drawer>
            <Grid container spacing={8}>
                <Grid item xs={12}>
                    {this.isProgressBarOpened ? <LinearProgress variant="query" color="secondary" /> : ""}
                    <AppBar position="static" >
                        <Toolbar>
                            <IconButton color="inherit" aria-label="Menu" onClick={this.drawerMenuClick}>
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                Náhled platebních údajů
                            </Typography>
                            <Button onClick={this.doSend} color="inherit">
                                Odeslat
                            </Button>
                        </Toolbar>
                    </AppBar>
                </Grid>
                <Grid item xs={12} style={{ margin: 8 }}>
                    {this.loadStarted && this.dataLoaded ? (
                    <Paper style={{ padding: 8 }}>
                        <Grid container item xs={12}>
                            <Grid item xs={2} style={{ margin: 8 }}>
                                <TextField fullWidth label="Adresa" value={this.emailAddress} onChange={this.handleChange('emailAddress')} />
                            </Grid>
                            <Grid item xs={2} style={{margin: 8}}>
                                <TextField label="Uložené adresy" id="choose-address" select onChange={this.handleChange('emailAddress')} 
                                    value="choose">
                                        <MenuItem value="choose">Zvolte uloženou adresu</MenuItem>
                                        {this.klienti.map(kl => (
                                            <MenuItem value={kl.email}>{kl.jmeno + " " + kl.prijmeni + "<" + kl.email + ">"}</MenuItem>
                                        ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} style={{ margin: 8, paddingTop: 24 }}>
                                <TextField label="Text email" multiline value={this.emailText} fullWidth onChange={this.handleChange('emailText')} />
                            </Grid>
                        </Grid>
                    </Paper>
                        ) : ""
                    }
                </Grid>
                </Grid>
                <Dialog
                open={this.isAlertDialogOpened}
                onClose={this.alertDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Asi došlo k chybě"}</DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Je nám líto, ale někde se stala chyba. Pokud máte trpělivost a touhu měnit svět k lepšímu,
                    nahlaste nám přesný čas události a my se pokusíme problém vyřešit.
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={this.alertDialogClose} color="primary" autoFocus variant="contained">
                    Budiž
                </Button>
                </DialogActions>
            </Dialog>
            </div>
        )
    }

}

export default withRouter(PaymentDetailsReview)


// WEBPACK FOOTER //
// ./src/components/PaymentDetailsReview.tsx